import { clsx } from 'clsx'

import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import {
  BlockWrapperComponent,
  LayoutBlockProps,
  LBC,
  UnknownProps,
} from '@tribeplatform/react-slate-kit/types'

import { EditorBlockExtraContext } from '../types.js'

export const LayoutWrapper: BlockWrapperComponent = ({
  Block,
  childrenBlocks,
}) => {
  const {
    block: { compiledProps },
    extraContext: { focused, selected, activated },
  } = useBlock<UnknownProps, EditorBlockExtraContext>()

  const LayoutBlock = Block as LBC<LayoutBlockProps>
  const layoutProps = compiledProps as LayoutBlockProps
  return (
    <LayoutBlock
      {...layoutProps}
      containerProps={{
        className: clsx(
          layoutProps?.containerProps?.className,
          (selected || focused) && [
            'rounded-md ring-offset-4 ring-2',
            focused && 'ring-customizer-blue border-customizer-blue',
            selected && 'ring-customizer-blue border-customizer-blue',
          ],
          activated && 'relative z-40 bg-background',
        ),
      }}
    >
      {childrenBlocks}
    </LayoutBlock>
  )
}
